import { toJson } from '@bufbuild/protobuf'

import type { Order } from '@jotta/grpc-connect-openapi/payment'
import { OrderSchema } from '@jotta/grpc-connect-openapi/payment'
import { useLocale } from '@jotta/i18n'
import { DefinitionListFromObject } from '@jotta/ui/DefinitionList'
import { formatPriceConnect } from '@jotta/utils/formatPrice'

export function BizOrderReceipt({ order }: { order: Order }) {
  const locale = useLocale()
  return (
    <>
      <table>
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Status</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {order.orderItems.map(item => (
            <tr key={item.productCode}>
              <td>{item.localizedName}</td>
              <td>{item.quantity}</td>
              <td>
                {formatPriceConnect(
                  {
                    amount: item.priceCents,
                    currency: order.currency,
                  },
                  locale,
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <DefinitionListFromObject value={toJson(OrderSchema, order)} />
    </>
  )
}
